var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "242.000000pt",
    height: "242.000000pt",
    viewBox: "0 0 242.000000 242.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,242.000000) scale(0.100000,-0.100000)",
    fill: "#C0BFC7",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030 1839 l0 -260 23 8 c28 10 193 11 230 0 l27 -7 0 260 0 260 -140 0 -140 0 0 -261z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547 1842 l-97 -97 183 -183 184 -184 33 52 c34 53 112 123 151 135 19 6 -1 30 -162 191 -101 101 -186 184 -189 184 -3 0 -49 -44 -103 -98z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1502 1757 l-184 -184 44 -26 c48 -28 92 -73 131 -132 l27 -39 182 182 183 182 -100 100 -100 100 -183 -183z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1045 1486 c-29 -13 -69 -44 -92 -70 -147 -167 -61 -428 156 -471 154 -31 296 59 336 211 35 133 -24 262 -147 323 -80 41 -176 43 -253 7z m207 -142 c40 -29 58 -67 58 -122 0 -149 -205 -196 -272 -62 -34 68 -13 144 52 188 28 19 45 23 86 20 29 -3 62 -13 76 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300 1230 l0 -140 255 0 255 0 -7 28 c-11 36 -10 179 0 220 l9 32 -256 0 -256 0 0 -140z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1524 1353 c27 -90 29 -177 5 -240 l-9 -23 260 0 260 0 0 140 0 140 -261 0 c-243 0 -260 -1 -255 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633 888 l-182 -183 99 -100 100 -100 184 184 184 184 -59 38 c-33 22 -74 59 -92 85 -17 25 -36 53 -42 60 -8 11 -50 -25 -192 -168z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1496 1038 c-31 -51 -86 -107 -134 -135 l-44 -26 184 -184 183 -183 100 100 100 100 -180 180 c-99 99 -182 180 -185 180 -3 0 -14 -14 -24 -32z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030 616 l0 -256 140 0 140 0 0 256 c0 246 -1 255 -19 249 -74 -23 -168 -23 -243 1 -17 5 -18 -11 -18 -250z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShine);
export default __webpack_public_path__ + "static/media/Shine.8f681c2fc9147c9bfadc0cf75698d5bb.svg";
export { ForwardRef as ReactComponent };